// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2vdAz","label":"SetPasswdForm_label__eHbEr"};